<template>
  <v-app>
    <Toolbar></Toolbar>
    <v-main style="background: #f2f2f2;padding-bottom: 200px;">
      <router-view/>
    </v-main>
  </v-app>
</template>

<style scoped>


@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');
*{
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif;
  letter-spacing: 0;
}

</style>


<script>
import Toolbar from './components/Toolbar.vue';

export default {
  name: 'App',
  components: {
    Toolbar
  },
  data() {
    return {
      datos: {
        nombre: '',
        cedula: '',
        tlf: '',
        username: ''
      }
    };
  }
};
</script>

